import React, { useState, useMemo } from "react";
import { useSearchIncome } from "../../../Services/Incomes";
import { Box, Stack, FormControl, InputLabel, Select, MenuItem, CircularProgress, Typography  } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { DiseñoDataGrid } from "../../../Components/FuncionesGenerales/DataGrid";
import { Input } from "../../../Layouts/CustomStyles";
import { MesesNombre } from "../../../Data/Mes";
import Logocolor from "../../../Image/Logo.png";

export const BuscadorIncome = () => {
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const { buscaringreso, loadings, error } = useSearchIncome(month, year);

const totalBruto = buscaringreso.reduce(
  (sum, i) => sum + parseFloat(i.total_amount || 0),
  0
);

  const availableYears = useMemo(() => {
    const years = buscaringreso.map((income) => new Date(income.date).getFullYear());
    return [...new Set(years)].sort((a, b) => b - a);
  }, [buscaringreso]);

  const formatCLP = (amount) =>
    new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
      minimumFractionDigits: 0,
    }).format(amount || 0);

  const columns = [
    
    {
      field: "branch",
      headerName: "Sucursal",
      flex: 1,
       renderCell: (params) => params?.row?.branch?.name ?? ""
  
    },
    {
      field: "contact",
      headerName: "Cliente",
      flex: 1,
      renderCell: (params) => params?.row?.contact?.name ?? ""

     
    },
    {
      field: "income_type",
      headerName: "Ingreso",
      flex: 1,
      renderCell: (params) => params?.row?.income_type?.name ?? ""

  
    },
   
    {
      field: "total_amount",
      headerName: "Bruto",
      flex: 0.8,
      renderCell: (params) => formatCLP(params.value),
    },
   
  
    {
      field: "user",
      headerName: "Administrador",
      flex: 1,
      renderCell: (params) => params?.row?.user?.name ?? ""

    },
  ];

  if (loadings)
    return (
       <Box
        sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "300px",
            gap: 2,
            position: "relative"
        }}
    >
        {/* Círculo */}
        <CircularProgress size={90} thickness={4} sx={{color:'#6fd385ff'}} />

        {/* Imagen centrada encima del círculo */}
        <Box
            component="img"
            src={Logocolor}
            alt="Logo"
            sx={{
                width: "55px",
                height: "55px",
                position: "absolute",
                top:"90px"
            }}
        />

        <Typography sx={{ fontFamily: "Poppins", fontSize: "18px", mt: 2 }}>
            Cargando...
        </Typography>
    </Box>
    );

  if (error) return <p>Error: {error}</p>;

  // Agregamos fila de totales como "footer"
  const rowsWithTotal = [
    ...buscaringreso,
    {
      id: "total",
      date: "Total",
      total_amount: totalBruto,
      branch: "",
      contact: "",
      income_type: "",
      concept: "",
      user: "",
    },
  ];

  return (
    <div style={{ height: 600, width: "100%" }}>
      <Stack direction="row" spacing={2} mb={2}>
        <FormControl sx={{ ...Input, width: 200 }}>
          <InputLabel>Mes</InputLabel>
          <Select value={month} label="Mes" onChange={(e) => setMonth(e.target.value)}>
            {MesesNombre.map((name, i) => (
              <MenuItem key={i + 1} value={i + 1}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ ...Input, minWidth: 200 }}>
          <InputLabel>Año</InputLabel>
          <Select value={year} onChange={(e) => setYear(e.target.value)}>
            {availableYears.map((y) => (
              <MenuItem key={y} value={y}>
                {y}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>

      <DataGrid
        rows={rowsWithTotal}
        columns={columns}
        getRowId={(row) => row.id}
        pageSize={10}
        rowsPerPageOptions={[5, 10, 25]}
        disableSelectionOnClick
        components={{
          Toolbar: GridToolbar,
        }}
        getRowClassName={(params) => (params.id === "total" ? "total-row" : "")}
         slots={{ noRowsOverlay: DiseñoDataGrid }}
                            sx={{
                                fontFamily: 'Poppins, sans-serif',
                                '& .MuiDataGrid-columnHeaders': {
                                    color: '#113e21ff',
                                    fontWeight: 600,
                                    textTransform: 'capitalize',
                                },
                                '& .MuiDataGrid-cell': {
                                    textTransform: 'capitalize',
                                },
                            }}
      />

      <style>{`
        .total-row {
          background-color: #4f9742ff;
          color: white;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
};
